import { Typography } from 'antd'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import {
  PHIEU_DAT_PHONG_HOP_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_CALENDAR_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_WAITING_APPROVAL_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_APPROVED_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL,
} from '../modules/phieu-dat-phong-hop/constants/config.phieu-dat-phong-hop'
import { PHONG_HOP_PREFIX_URL } from '../modules/phong-hop/constants/config.phong-hop'
import { THIET_BI_PHONG_HOP_PREFIX_URL } from '../modules/thiet-bi-phong-hop/constants/config.thiet-bi-phong-hop'
import { DAT_PHONG_HOP_PREFIX_URL } from './config.dat-phong-hop'
import { ADMIN_PHONG_HOP_PREFIX_URL } from '../modules/admin-phong-hop/constants/config.admin-phong-hop'

const CONFIG_PREFIX_URL = 'config'

const LIST_MENU_REPORT: CustomMenuItemType<'submenu'>['children'] = [
  {
    key:
      NO_NAVIGATE_KEY +
      DAT_PHONG_HOP_PREFIX_URL +
      PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL,
    label: 'Báo cáo',
    type: 'submenu',
    children: [
      {
        key: `${DAT_PHONG_HOP_PREFIX_URL}${PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL}/by-phong-hop`,
        label: 'Theo phòng họp',
      },
      {
        key: `${DAT_PHONG_HOP_PREFIX_URL}${PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL}/by-phong-ban`,
        label: 'Theo phòng ban',
      },
    ],
  },
]

const LIST_MENU_CALENDAR: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: DAT_PHONG_HOP_PREFIX_URL + PHIEU_DAT_PHONG_HOP_CALENDAR_PREFIX_URL,
    label: 'Lịch đặt phòng họp',
  },
]

const LIST_MENU_CAU_HINH: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: NO_NAVIGATE_KEY + DAT_PHONG_HOP_PREFIX_URL + CONFIG_PREFIX_URL,
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key: DAT_PHONG_HOP_PREFIX_URL + ADMIN_PHONG_HOP_PREFIX_URL,
        label: 'Admin phòng họp',
      },
      {
        key: DAT_PHONG_HOP_PREFIX_URL + THIET_BI_PHONG_HOP_PREFIX_URL,
        label: 'Thiết bị phòng họp',
      },
      {
        key: DAT_PHONG_HOP_PREFIX_URL + PHONG_HOP_PREFIX_URL,
        label: 'Phòng họp',
      },
    ],
  },
]

const LIST_MENU_PHIEU_DAT_PHONG_HOP: CustomMenuItemType<'submenu'>['children'] =
  [
    {
      key:
        NO_NAVIGATE_KEY +
        DAT_PHONG_HOP_PREFIX_URL +
        PHIEU_DAT_PHONG_HOP_PREFIX_URL,
      label: 'Phiếu đặt phòng họp',
      children: [
        {
          key: DAT_PHONG_HOP_PREFIX_URL + PHIEU_DAT_PHONG_HOP_PREFIX_URL,
          label: 'Tất cả',
        },
        {
          key:
            DAT_PHONG_HOP_PREFIX_URL +
            PHIEU_DAT_PHONG_HOP_WAITING_APPROVAL_PREFIX_URL,
          label: 'Chờ tôi duyệt',
        },
        {
          key:
            DAT_PHONG_HOP_PREFIX_URL + PHIEU_DAT_PHONG_HOP_APPROVED_PREFIX_URL,
          label: 'Đã được duyệt',
        },
      ],
    },
  ]

const generateMenu = (
  children: CustomMenuItemType<'submenu'>['children']
): CustomMenuItemType<'submenu'> => ({
  key: `${NO_NAVIGATE_KEY}${DAT_PHONG_HOP_PREFIX_URL}`,
  label: (
    <Typography.Link strong ellipsis title="Đặt phòng họp">
      Đặt phòng họp
    </Typography.Link>
  ),
  icon: <IconGlobalApp name="house-plus" />,
  children,
})

export const LIST_MENU_DAT_PHONG_HOP_ADMIN = generateMenu([
  ...LIST_MENU_CALENDAR,
  ...LIST_MENU_PHIEU_DAT_PHONG_HOP,
  ...LIST_MENU_REPORT,
  ...LIST_MENU_CAU_HINH,
])

export const LIST_MENU_DAT_PHONG_HOP_EMPLOYEE = generateMenu([
  ...LIST_MENU_CALENDAR,
  ...LIST_MENU_PHIEU_DAT_PHONG_HOP,
])
